export default __webpack_public_path__ + "static/media/003.d1fe76df.jpg";